// esbuild entry: bundle front-end JS modules
// Register submodules that augment the UI
import './toc.js';
import './shuffle-text.js';
import './lightbox.js';
